module.exports = __webpack_public_path__ + "img/noWifi.f864c31e.svg";